import React from "react";

import "../styles.scss";
import "../scripts";

import {
  primaryBlock,
  PrimaryBlockConfig,
  getDefaultProps,
  KameleonElement,
  SecondaryBlockSize,
  TertiaryBlockSize,
  BlockTheme,
  renderSecondaryBlock,
  BlockType,
} from "@kameleon-core/lib";
import { Box } from "theme-ui";

import { Variants } from "@kameleon-util/global-theme";
import blockinfo from "./blockinfo.json";
import defaults from "./defaults.json";
import { ContentType, layoutOptions } from "./types/prop-types";

/** Content Primary */
const blockConfig: PrimaryBlockConfig = {
  secondaryBlockSize: SecondaryBlockSize.ExtraSmall,
  tertiaryBlockSize: TertiaryBlockSize.None,
  blockType: BlockType.Primary,
  blockTheme: BlockTheme.light,
};

export const Content = primaryBlock<ContentType>(
  blockConfig,
  ({
    SecondaryBlock,
    tagline,
    header,
    description,
    image,
    items,
    layoutProps,
  }: ContentType) => {
    // const alignmentIsCenter = layoutProps.textAlignment === "center"

    const leftItems = items.slice(
      0,
      items.length % 2 === 0 ? items.length / 2 : items.length / 2 + 1
    );
    const rightItems = items.slice(leftItems.length, items.length);

    const Item = (i: number, { icon, text, title }: any, placement: string) => (
      <Box key={`${placement}-${i}`} className="layout254_item">
        <Box className="margin-bottom margin-small icon-background is-forsmallicon">
          <Variants.IconSmall
            hasBg={layoutProps.showIconBackground}
            icon={icon}
          />
        </Box>
        <Box className="margin-bottom margin-xsmall">
          <Variants.Heading as="h3" variant="h5">
            {title}
          </Variants.Heading>
        </Box>
        <Variants.ParagraphDefault>{text}</Variants.ParagraphDefault>
      </Box>
    );

    return (
      <Box className="primary-content-three-col-centered-image-v1 section_layout254">
        <Box className="padding-global">
          <Box className="container-large padding-section-large layout254_component">
            {(header || description) && (
              <Box
                className={`margin-bottom margin-xxlarge max-width-large ${
                  layoutProps.textAlignment === "center" && "align-center"
                }`}
              >
                {tagline && (
                  <Box className="margin-bottom margin-xsmall">
                    <Variants.TagLine>{tagline}</Variants.TagLine>
                  </Box>
                )}
                {header && (
                  <Box className="margin-bottom margin-small">
                    <Variants.Heading>{header}</Variants.Heading>
                  </Box>
                )}
                {description && (
                  <Variants.ParagraphMedium>
                    {description}
                  </Variants.ParagraphMedium>
                )}
              </Box>
            )}
            <Box className="layout254_content-bottom">
              <Box className="layout254_left">
                {leftItems.map((item, i) => Item(i, item, "left"))}
              </Box>
              <Box
                id="w-node-dfbce600-fd05-e93d-baa8-fb9fcf28d664-38d4ce7a"
                className="layout254_image-wrapper"
              >
                <Variants.Image
                  src={image.url}
                  loading="lazy"
                  alt={image.alt}
                  className="layout254_image"
                />
              </Box>
              <Box className="layout254_right">
                {rightItems.map((item, i) => Item(i, item, "right"))}
              </Box>
            </Box>
            {SecondaryBlock && (
              <Box className="secondary">
                {renderSecondaryBlock(SecondaryBlock)}
              </Box>
            )}
          </Box>
        </Box>
      </Box>
    );
  }
);

Content.defaultProps = getDefaultProps<ContentType>(defaults);

export const Element: KameleonElement = {
  component: Content,
  blockInfo: blockinfo,
  defaultProps: {
    layoutProps: defaults.layoutProps,
    contentProps: defaults.contentProps,
  },
  layoutOptions,
};
